function clamp (v, min, max) {
    return Math.min(Math.max(v, min), max)
}

function compareDate (a, b) {
    return b.date.localeCompare(a.date)
}

function hexToRgb (hex) {
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex)
    return result ? `rgb(${parseInt(result[1], 16)}, ${parseInt(result[2], 16)}, ${parseInt(result[3], 16)})` : null
}

export {
    clamp,
    compareDate,
    hexToRgb
}
